<template>
  <fieldset
    class="BlockInput"
    :disabled="disabled"
    @click="blockInputClick"
    ref="BlockInput"
  >
    <div class="BlockInputInner" @focusout="blockFocusOut">
      <span class="BlockInputLabel" :class="{ Required: isRequired }">
        <slot name="label">{{ label }}</slot
        >&nbsp;
      </span>
      <div class="BlockInputControl">
        <slot>
          <input type="text" />
        </slot>
      </div>
      <!-- <span class="BlockInputErrorMessage" v-if="isInvalid.isEmpty"
        >Required</span
      > -->
      <span class="BlockInputErrorMessage" v-if="isInvalid.value">
        <slot name="errorMessage">{{ errorMessage }}</slot>
      </span>
      <span class="BlockInputDescription">
        &nbsp;
        <slot name="description">{{ description }}</slot>
      </span>
    </div>
  </fieldset>
</template>
<script>
export default {
  name: "BlockInput",
  props: {
    label: { default: "" },
    description: { default: "" },
    isRequired: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    errorMessage: { default: "" },
    showError: { default: true },
  },
  data() {
    return {
      isInvalid: { value: false, isEmpty: false },
    };
  },
  methods: {
    blockInputClick(e) {
      let inputControl = e.target
        .closest(".BlockInput")
        .querySelector("input,select,[contenteditable]");
      if (inputControl) {
        //inputControl.focus();
      }
    },
    blockFocusOut(e) {
      if (this.showError) {
        let _isInvalid = this.isInvalid;
        let _isRequired = this.isRequired;

        let inputControl = this.$refs.BlockInput.querySelector("input");
        let inputControl1 = this.$refs.BlockInput.querySelector("textarea");
        window.setTimeout(function () {
          if (inputControl) {
            if (inputControl.classList.contains("AcceptInput")) {
              if (inputControl.classList.contains("invalidInput")) {
                _isInvalid.value = true;
                if (inputControl.value == "") {
                  _isInvalid.isEmpty = true;
                } else {
                  _isInvalid.isEmpty = false;
                }
              } else {
                _isInvalid.value = false;
                if (inputControl.value == "" && _isRequired) {
                  _isInvalid.isEmpty = true;
                } else {
                  _isInvalid.isEmpty = false;
                }
              }
            } else {
              if (inputControl.value == "" && _isRequired) {
                _isInvalid.isEmpty = true;
                inputControl.classList.add("invalidInput");
              } else {
                _isInvalid.isEmpty = false;
                inputControl.classList.remove("invalidInput");
              }
            }
          }
          if (inputControl1) {
            if (inputControl1.classList.contains("AcceptTextArea")) {
              if (inputControl1.classList.contains("invalidInput")) {
                _isInvalid.value = true;
                if (inputControl1.value == "") {
                  _isInvalid.isEmpty = true;
                } else {
                  _isInvalid.isEmpty = false;
                }
              } else {
                _isInvalid.value = false;
                if (inputControl1.value == "" && _isRequired) {
                  _isInvalid.isEmpty = true;
                } else {
                  _isInvalid.isEmpty = false;
                }
              }
            }
          }
        }, 100);
      }
    },
  },
  mounted() {
    document
      .querySelectorAll(
        ".BlockInput input:not([hasCross]):not([type='radio']):not([type='checkbox']):not([type='button']):not([type='submit']):not([type='hidden'])"
      )
      .forEach((x) => {
        x.setAttribute("hasCross", "true");
        let btnClearInput = document.createElement("a");
        btnClearInput.className = "btnClearInput";
        btnClearInput.innerHTML = "X";
        btnClearInput.onclick = function () {
          x.value = "";
          //x.focus();
        };
        x.addEventListener("keydown", function (e) {
          if (e.which === 27) {
            x.value = "";
          }
        });
        x.parentNode.appendChild(btnClearInput);
      });
  },
};
</script>
<style>
.BlockInput {
  position: relative;
  margin: 0px;
  padding: 0px;
  border: none;
  background-color: transparent;
}
.BlockInputInner {
  border: solid 1px transparent;
  padding: 2px;
}
.BlockInputInner:focus-within,
.BlockInputInner:active {
  background-color: rgba(50, 0, 0, 0.3);
  border: solid 1px;
  width: 100%;
  height: 60px;
  position: absolute;
  z-index: 9999999;
}
.BlockInputDescription {
  font-size: 80%;
  color: white;
  display: none;
  /*white-space: nowrap;*/
  width: 100%;
  overflow: hidden;
  transition: all 300ms ease-in-out;
  opacity: 0;
}
.BlockInputInner:focus-within .BlockInputDescription,
.BlockInputInner:active .BlockInputDescription {
  display: block;
  opacity: 1;
  position: absolute;
  transition: all 1000ms ease-in-out;
}
.BlockInputLabel {
  position: relative;
  display: block;
}
.BlockInputLabel.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}
.BlockInputControl {
  position: relative;
}
.btnClearInput {
  position: absolute;
  right: 5px;
  top: 5px;
  color: black;
  opacity: 0;
}
.BlockInputInner:focus-within .btnClearInput {
  opacity: 1;
}
.BlockInputErrorMessage {
  color: red;
  display: block;
}
.SearchDropDownSearch .btnClearInput {
  top: 10px;
  right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ekkControls/BlockInput.vue